<template>
  <div class="id-page">
    <div class="mobile-frame">
      <header class="topbar">
        <div class="left-part">
          <button class="icon-btn" type="button" aria-label="返回" @click="goBack">
            <i class="el-icon-arrow-left"></i>
          </button>
          <button class="icon-btn ghost" type="button" aria-label="回到首页" @click="goHome">
            <i class="el-icon-house"></i>
          </button>
          <span>身份证</span>
        </div>
        <div class="right-part">
          <button class="icon-btn ghost" type="button" aria-label="收藏">
            <i class="el-icon-star-off"></i>
          </button>
          <button class="icon-btn ghost" type="button" aria-label="更多">
            <i class="el-icon-more"></i>
          </button>
          <button class="icon-btn ghost" type="button" aria-label="回到首页" @click="goHome">
            <span class="exit-ring" aria-hidden="true"></span>
          </button>
        </div>
      </header>

      <div class="img-list">
        <img class="id-image" :src="frontImage" alt="身份证人像面" />
        <img class="id-image" :src="backImage" alt="身份证国徽面" />
      </div>

      <div class="bottom-action">
        <div class="action-left">
          <i class="el-icon-upload2"></i>
          <span>更新证照图片</span>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import frontImage from "@/assets/alipay-id-front.png";
import backImage from "@/assets/alipay-id-back.png";

export default {
  name: "AlipayIdImageUpdate",
  data() {
    return {
      frontImage,
      backImage,
    };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goHome() {
      this.$router.push({ name: "AlipayFlowHome" });
    },
  },
};
</script>

<style scoped>
.id-page {
  min-height: 100vh;
  background: #f5f5f5;
  display: flex;
  justify-content: center;
}

.mobile-frame {
  width: 100%;
  max-width: 430px;
  box-sizing: border-box;
  padding-bottom: 16px;
  background: #f5f5f5;
}

.status-bar {
  height: 30px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  color: #1e1e1e;
}

.status-time {
  font-weight: 600;
}

.status-right {
  font-weight: 600;
}

.topbar {
  height: 52px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  box-sizing: border-box;
}

.left-part {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1e1e1e;
}

.left-part span {
  font-size: 22px;
  font-weight: 700;
}

.left-part .icon-btn {
  padding: 6px;
  margin: 0 -2px;
}

.topbar .icon-btn i {
  font-size: 21px;
}

.icon-btn {
  border: none;
  background: transparent;
  padding: 8px;
  cursor: pointer;
  color: #1f1f1f;
  font-size: 22px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-btn.ghost {
  color: #2c2c2c;
}

.icon-btn:active {
  opacity: 0.45;
}

/* 与身份信息页一致：小程序关闭样式 */
.exit-ring {
  display: block;
  width: 20px;
  height: 20px;
  border: 1.5px solid #2c2c2c;
  border-radius: 50%;
  box-sizing: border-box;
  position: relative;
}

.exit-ring::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 7px;
  height: 7px;
  margin: -3.5px 0 0 -3.5px;
  border: 1.5px solid #2c2c2c;
  border-radius: 50%;
  box-sizing: border-box;
}

.right-part {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 2px;
}

.img-list {
  padding: 42px 28px 18px;
  background: linear-gradient(180deg, #a8e2ff 0%, #d9f0fb 12%, #f5f5f5 42%);
}


.id-image {
  width: 100%;
  display: block;
  border-radius: 1px;
  margin-bottom: 14px;
  height: auto;
}

.bottom-action {
  background: #fff;
  height: 62px;
  margin-top: 8px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #9ea7b3;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
}

.action-left {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  color: #2b2f36;
}

.action-left i {
  color: #6cb5ff;
  font-size: 24px;
}

.bottom-action > i {
  font-size: 17px;
  color: #c4c4c4;
}
</style>
